import { render, staticRenderFns } from "./progress-tabs.vue?vue&type=template&id=ffa2ef2c&"
import script from "./progress-tabs.vue?vue&type=script&lang=js&"
export * from "./progress-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports